<template>
  <modal ref="modal">
    <template v-slot:header>
       <div class="text-center"><a class="text-blue-800" href="https://www.the-increaser.com/" target="_blank">The Increaser</a></div>
    </template>
    <div><p class="text-center">Built a web portal for hotel vendors that integrates with an existing system in less than a month.</p>
      <br/>
      <div class="bg-gray-300 font-mono p-2">
    <p>- Used <a class="text-blue-500 hover:text-blue-800" href="https://www.ruby-lang.org/en/" target="_blank">Ruby</a> on <a class="text-blue-500 hover:text-blue-800" href="https://rubyonrails.org/" target="_blank">Rails</a> to build the backend, <a class="text-blue-500 hover:text-blue-800" href="https://vuejs.org/" target="_blank">Vue.js</a> as frontend and <a class="text-blue-500 hover:text-blue-800" href="https://www.postgresql.org/" target="_blank">PostgreSQL</a> for the database.</p></div>
    </div>
  </modal>
</template>
<script>
  import Modal from './Modal.vue'

  export default {
    components: {
      Modal
    },

    methods: {
      open () {
        this.$refs.modal.open()
      },
      close () {
        this.$refs.modal.close()
      }
    }
  }
</script>
<style>
  a {
    color:;
  }
</style>
